/* ============================================================
   dm-animations.js - 強化版
   ============================================================ */

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {

    console.log('[DM Animation] 初期化開始');
    console.log('[DM Animation] .dm-fade-up 要素数:', document.querySelectorAll('.dm-fade-up').length);
    console.log('[DM Animation] .dm-stagger 要素数:', document.querySelectorAll('.dm-stagger').length);

    const fadeObs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          console.log('[DM Animation] フェードアップ発火:', entry.target.className);
          entry.target.classList.add('is-visible');
          fadeObs.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -50px 0px',
      threshold: 0,
    });

    document.querySelectorAll('.dm-fade-up').forEach((el) => {
      fadeObs.observe(el);
    });

    const lineObs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          lineObs.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -50px 0px',
      threshold: 0,
    });

    document.querySelectorAll('.dm-line-reveal').forEach((el) => {
      lineObs.observe(el);
    });

    const staggerObs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          console.log('[DM Animation] スタガー発火:', entry.target.className);
          Array.from(entry.target.children).forEach((child, i) => {
            child.style.setProperty('--stagger-index', i);
          });
          entry.target.classList.add('is-visible');
          staggerObs.unobserve(entry.target);
        }
      });
    }, {
      rootMargin: '0px 0px -30px 0px',
      threshold: 0,
    });

    document.querySelectorAll('.dm-stagger').forEach((el) => {
      staggerObs.observe(el);
    });

    /* ─── 画像パララックス ─────────────────────────────────
       .dm-parallax 要素をスクロールに応じてゆっくり動かす。
       requestAnimationFrameで間引き、画面内にある間だけ処理する
       （パフォーマンスへの影響を最小限にするため）。
       スマホでは負荷軽減のため無効化（多くの端末で体感差が薄いため）。 */

    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const parallaxEls = document.querySelectorAll('.dm-parallax');

    if (parallaxEls.length && !isMobile) {
      let ticking = false;
      const activeEls = new Set();

      /* 画面内にある間だけ計算対象にする（負荷軽減） */
      const parallaxObs = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            activeEls.add(entry.target);
          } else {
            activeEls.delete(entry.target);
          }
        });
      }, { threshold: 0 });

      parallaxEls.forEach((el) => parallaxObs.observe(el));

      function updateParallax() {
        activeEls.forEach((el) => {
          const speed = parseFloat(el.dataset.parallaxSpeed || '0.3');
          const rect = el.parentElement.getBoundingClientRect();
          /* セクション中央が画面中央からどれだけずれているかで移動量を決定 */
          const offset = rect.top * speed;
          el.style.transform = `translate3d(0, ${offset}px, 0)`;
        });
        ticking = false;
      }

      function onScroll() {
        if (!ticking) {
          window.requestAnimationFrame(updateParallax);
          ticking = true;
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      updateParallax(); /* 初期表示分も反映 */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
